import React from 'react';
import { Route } from 'react-router-dom';
import { CopyFunctionPage } from './Routes';

export const routes = [<Route key={0} path="/copy-function" component={CopyFunctionPage} />];

export const navigation = [{ name: 'copy_function', link: '/copy-function', icon: 'Binder' }];
